export default function($) {
  $('.cssAnimate').waypoint(function (direction) {
    var $element = $(this.element);
    if ($element.hasClass('image-text-large')) {
      if ($element.hasClass('image-text-reversed')) {
        $element.addClass('animate-in slide-in-from-left-full duration-1000').removeClass('cssAnimate');
      } else {
        $element.addClass('animate-in slide-in-from-right-full duration-1000').removeClass('cssAnimate');
      }
    }

    if ($element.hasClass('js-image-text-bg')) {
      $element.addClass('animate-background-size').removeClass('cssAnimate');
    }

    if ($element.hasClass('js-image-text-content')) {
      $element.addClass('animate-in slide-in-from-bottom-12 fade-in duration-1000 delay-1000').removeClass('cssAnimate');
    }
    if ($element.hasClass('js-image-text-img')) {
      if ($element.closest('.image-text-large').hasClass('image-text-reversed')) {
        $element.addClass('js-image-text-img-animation-right').removeClass('cssAnimate');
      } else {
        $element.addClass('js-image-text-img-animation').removeClass('cssAnimate');
      }
    }
  }, { offset: '80%' });
}
